import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faCar, faIndianRupeeSign, faFileUpload, faChevronDown, faPlus } from '@fortawesome/free-solid-svg-icons';
import PageHeadingSection from '../../../../common/pageheading/PageHeadingSection';
import Breadcrumbs from '../../../../common/BreadCrum/BreadCrum';
import { mockEligibleSlots } from './dummyData';
import { primaryColor } from '../../../../../utils/comon';

const OfferLease = () => {
    const navigate = useNavigate();
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [formData, setFormData] = useState({
        monthlyRent: '3500',
        securityDeposit: '7000',
        startDate: '',
        endDate: '',
        additionalPolicy: ''
    });

    const handleInputChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    return (
        <div className="bg-dashboardbg px-4 sm:px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto h-full relative scrollbar-hide">
            <Breadcrumbs />
            <PageHeadingSection
                Navbar={true}
                mainHeading="Offer Commercial Lease to Site"
                subHeading="Submit a direct parking lease proposal to Building Management"
            />

            <div className="mt-4 flex flex-col gap-4 w-full">
                {/* Target Section */}
                <div className="bg-blue-50/50 border border-blue-200 rounded-xl p-3 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center text-lg">
                            <FontAwesomeIcon icon={faBuilding} />
                        </div>
                        <div>
                            <h3 className="text-xs font-bold text-gray-800">Site / Building Management</h3>
                            <p className="text-[10px] text-gray-500 mt-0.5">Commercial lease proposal offered directly to Site Admin for centralized building allocation</p>
                        </div>
                    </div>
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 text-[9px] font-bold rounded-full uppercase tracking-wider">
                        Exclusive Target
                    </span>
                </div>

                {/* Slot Selection */}
                <div className="bg-white dark:bg-cardbg border border-gray-200 dark:border-bordercolor rounded-xl overflow-hidden shadow-sm">
                    <div className="bg-gray-50 dark:bg-actionitembg px-4 py-2 border-b border-gray-200 dark:border-bordercolor flex items-center justify-between cursor-pointer">
                        <div className="flex items-center gap-2 text-red-500 font-bold text-xs">
                            <FontAwesomeIcon icon={faCar} />
                            SELECT ELIGIBLE PARKING SLOT
                        </div>
                        <FontAwesomeIcon icon={faChevronDown} className="text-gray-400 text-xs" />
                    </div>
                    <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-3">
                        {mockEligibleSlots.map((slot) => (
                            <div 
                                key={slot.id}
                                onClick={() => setSelectedSlot(slot.id)}
                                className={`border rounded-lg p-3 cursor-pointer transition-all ${
                                    selectedSlot === slot.id 
                                        ? "border-red-500 bg-red-50/30" 
                                        : "border-gray-200 hover:border-gray-300"
                                }`}
                            >
                                <div className="flex items-center justify-between mb-1.5">
                                    <div className="flex items-center gap-2">
                                        <div className={`w-3.5 h-3.5 rounded-full border-2 flex items-center justify-center ${
                                            selectedSlot === slot.id ? "border-red-500" : "border-gray-300"
                                        }`}>
                                            {selectedSlot === slot.id && <div className="w-1.5 h-1.5 bg-red-500 rounded-full"></div>}
                                        </div>
                                        <span className="font-bold text-xs text-gray-800 dark:text-textprimary">{slot.label}</span>
                                    </div>
                                    <span className="px-2 py-0.5 bg-green-100 text-green-700 text-[9px] font-bold rounded">
                                        Available
                                    </span>
                                </div>
                                <p className="text-[10px] text-gray-500 pl-5">{slot.details}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Financial Terms */}
                <div className="bg-white dark:bg-cardbg border border-gray-200 dark:border-bordercolor rounded-xl overflow-hidden shadow-sm">
                    <div className="bg-gray-50 dark:bg-actionitembg px-4 py-2 border-b border-gray-200 dark:border-bordercolor flex items-center justify-between cursor-pointer">
                        <div className="flex items-center gap-2 text-red-500 font-bold text-xs">
                            <FontAwesomeIcon icon={faIndianRupeeSign} />
                            FINANCIAL TERMS & PRICING
                        </div>
                        <FontAwesomeIcon icon={faChevronDown} className="text-gray-400 text-xs" />
                    </div>
                    <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-[11px] font-bold text-gray-700 mb-1.5">Monthly Rent (₹) <span className="text-red-500">*</span></label>
                            <input 
                                type="number" 
                                name="monthlyRent"
                                value={formData.monthlyRent}
                                onChange={handleInputChange}
                                className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:border-red-500 bg-gray-50/50" 
                            />
                        </div>
                        <div>
                            <label className="block text-[11px] font-bold text-gray-700 mb-1.5">Security Deposit (₹) <span className="text-red-500">*</span></label>
                            <input 
                                type="number" 
                                name="securityDeposit"
                                value={formData.securityDeposit}
                                onChange={handleInputChange}
                                className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:border-red-500 bg-gray-50/50" 
                            />
                        </div>
                        <div>
                            <label className="block text-[11px] font-bold text-gray-700 mb-1.5">Start Date</label>
                            <input 
                                type="date" 
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleInputChange}
                                className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:border-red-500 bg-gray-50/50 text-gray-500" 
                            />
                        </div>
                        <div>
                            <label className="block text-[11px] font-bold text-gray-700 mb-1.5">End Date</label>
                            <input 
                                type="date" 
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleInputChange}
                                className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:border-red-500 bg-gray-50/50 text-gray-500" 
                            />
                        </div>
                        <div className="md:col-span-2">
                            <label className="block text-[11px] font-bold text-gray-700 mb-1.5">Additional Policy & Usage Clauses</label>
                            <input 
                                type="text" 
                                name="additionalPolicy"
                                value={formData.additionalPolicy}
                                onChange={handleInputChange}
                                className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:border-red-500 bg-gray-50/50" 
                                placeholder="e.g. Subject to management approval..."
                            />
                        </div>
                    </div>
                </div>

                {/* Attach Documents */}
                <div className="bg-white dark:bg-cardbg border border-gray-200 dark:border-bordercolor rounded-xl overflow-hidden shadow-sm">
                    <div className="bg-gray-50 dark:bg-actionitembg px-4 py-2 border-b border-gray-200 dark:border-bordercolor flex items-center justify-between cursor-pointer">
                        <div className="flex items-center gap-2 text-red-500 font-bold text-xs">
                            <FontAwesomeIcon icon={faFileUpload} />
                            ATTACH INITIAL DRAFT DOCUMENTS (OPTIONAL)
                        </div>
                        <FontAwesomeIcon icon={faChevronDown} className="text-gray-400 text-xs" />
                    </div>
                    <div className="p-4">
                        <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors">
                            <span className="material-symbols-outlined text-3xl text-gray-400 mb-1">upload_file</span>
                            <span className="text-red-500 font-bold text-xs mb-1">Click to upload Draft Agreement PDF / Document</span>
                            <span className="text-gray-400 text-[10px]">Upload preliminary lease templates or property guidelines</span>
                        </div>
                    </div>
                </div>

                {/* Footer Buttons */}
                <div className="flex items-center justify-end gap-3 mt-2 pb-10">
                    <button 
                        onClick={() => navigate('/zentcomm/parking-management/rental-parking')}
                        className="px-5 py-2 rounded-lg text-xs font-bold bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={() => navigate('/zentcomm/parking-management/rental-parking')}
                        className="px-5 py-2 rounded-lg text-xs font-bold text-white transition-colors flex items-center gap-2 bg-red-500 hover:bg-red-600"
                        style={{ backgroundColor: primaryColor() }}
                    >
                        <FontAwesomeIcon icon={faPlus} /> Submit Lease Offer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OfferLease;
